import { CheckIcon } from "lucide-react";
import { Button } from "../../ui/button";

type SuccessBannerProps = {
  title: string;
  description: string;
  buttonText: string;
  onButtonClick: () => void;
};

export default function SuccessBanner({
  title,
  description,
  buttonText,
  onButtonClick,
}: SuccessBannerProps) {
  return (
    <div className="flex flex-col items-center justify-center p-8 text-center space-y-6">
      <div className="rounded-full bg-green-100 p-3 w-16 h-16 flex items-center justify-center">
        <CheckIcon className="w-8 h-8 text-green-600" />
      </div>
      <h2 className="text-2xl font-semibold text-green-800">{title}</h2>
      <p className="text-green-700 max-w-md">{description}</p>
      <Button variant="outline" onClick={onButtonClick}>
        {buttonText}
      </Button>
    </div>
  );
}
